import { useVehicleFilter, VehicleFilter } from '../contexts/VehicleFilterContext'
import { Car, Truck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// Labels are keys, translated at render so they follow a language switch.
const filterOptions: { value: VehicleFilter; labelKey: 'vehicleFilter.alle' | 'vehicleFilter.personbil' | 'vehicleFilter.varebil'; icon?: React.ReactNode }[] = [
  { value: 'alle', labelKey: 'vehicleFilter.alle' },
  { value: 'personbil', labelKey: 'vehicleFilter.personbil', icon: <Car className="w-3.5 h-3.5" /> },
  { value: 'varebil', labelKey: 'vehicleFilter.varebil', icon: <Truck className="w-3.5 h-3.5" /> },
]

interface VehicleFilterToggleProps {
  disabledOptions?: VehicleFilter[]
  disabledTooltip?: string
}

export default function VehicleFilterToggle({ disabledOptions, disabledTooltip }: VehicleFilterToggleProps) {
  const { t } = useTranslation('components')
  const { vehicleFilter, setVehicleFilter } = useVehicleFilter()

  return (
    <div className="flex items-center">
      <div className="flex rounded-lg border border-gray-200 dark:border-dark-border overflow-hidden">
        {filterOptions.map((option) => {
          const isDisabled = disabledOptions?.includes(option.value) ?? false
          const label = t(option.labelKey)
          return (
            <button
              key={option.value}
              onClick={() => !isDisabled && setVehicleFilter(option.value)}
              disabled={isDisabled}
              className={`
                px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-1.5
                ${isDisabled
                  ? 'bg-gray-100 dark:bg-dark-card text-gray-300 dark:text-gray-600 cursor-not-allowed'
                  : vehicleFilter === option.value
                    ? 'bg-primary-500 text-white'
                    : 'bg-white dark:bg-dark-card text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-border'
                }
                ${option.value !== 'alle' ? 'border-l border-gray-200 dark:border-dark-border' : ''}
              `}
              title={isDisabled && disabledTooltip ? disabledTooltip : t('vehicleFilter.show', { label: label.toLowerCase() })}
            >
              {option.icon}
              <span>{label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
